import { FC } from 'react'
import mclasses from '../../styles/modal.module.css'
import Modal from '@common/Modal'
import { crmApi } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import { Lead, LeadState } from '@/api/types/crm.types'
import { isError } from '@/helpers/checkQuery'
import { getLeadFieldValue } from '../../utils/leadFields'

interface DeleteLeadModalProps {
  keyTable: LeadState
  lead?: Lead | Lead[]
  open: boolean
  onClose: () => void
  onSuccess?: () => void
  // onDismiss: () => void
}

const DeleteLeadModal: FC<DeleteLeadModalProps> = ({
  keyTable,
  lead,
  open,
  onSuccess,
  onClose,
}) => {
  const addAlert = useAddAlert()

  const handleConfirm = async () => {
    if (!lead) {
      addAlert({ text: 'Ошибка', type: 'error' })
      return
    }

    try {
      const res = await crmApi.removeLeads(
        { type: keyTable },
        {
          lead_ids: !Array.isArray(lead)
            ? [lead.id]
            : lead.map((lead) => lead.id),
        },
      )

      if (isError(res)) throw new Error()
      onSuccess && onSuccess()
      addAlert({ title: 'Успешно', text: `Успешно удалено`, type: 'success' })
      onClose()
    } catch (error) {
      addAlert({ title: 'Ошибка', text: 'Ошибка удаления', type: 'error' })
    }
  }

  const getSelectedNames = () => {
    if (!Array.isArray(lead)) return getLeadFieldValue(lead, 'NAME')
    return lead?.map((lead) => getLeadFieldValue(lead, 'NAME')).join(', ')
  }

  return (
    <Modal
      active={open}
      className={mclasses.modalWrapper as any}
      setActive={() => onClose()}
    >
      <div className={mclasses.modalContainer}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>
              Вы уверены что хотите удалить?
            </span>
          </div>
          <div className={mclasses.closeIcon} onClick={() => onClose()}>
            <IcoRemove />
          </div>
        </div>
        <div className={mclasses.formWrapper}>
          <p>{getSelectedNames()}</p>
        </div>
        <div className={mclasses.actions}>
          <Button color="gray" onClick={() => onClose()}>
            Отменить
          </Button>
          <Button color="primary" onClick={() => handleConfirm()}>
            Подтвердить
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteLeadModal
